<template>
    <hints-store
        v-slot="{
            store
        }"
        @error="onHintsStoreError"
    >
        <div
            v-if="is_open"
            class="px-4 py-4 mb-6 border rounded sm:px-6 text-grey-darker"
        >
            <div class="flex items-start mb-3">
                <h6 class="flex-grow pr-3 text-lg font-semibold text-grey-darkest">
                    <slot name="heading" />
                </h6>

                <button
                    class="flex-none w-6 h-6"
                    @click.prevent="store(form); is_open = false"
                >
                    <base-svg
                        name="icon-close-circle"
                        class="w-full h-full"
                    />
                </button>
            </div>

            <slot />
        </div>
    </hints-store>
</template>

<script>
    import _ from 'lodash'
    import HintsStore from './hints-store'

    export default {
        components: {
            HintsStore
        },
        props: {
            name: {
                type: String,
                required: true
            },
            forceOpen: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                is_open: false
            }
        },
        computed: {
            form () {
                return {
                    name: this.name,
                    read_at: this.$moment().format('HH:mm:ss DD/MM/YYYY')
                }
            }
        },
        created () {
            this.is_open = this.forceOpen || _.chain(_.preload('hints.data') || [])
                .find({
                    name: this.name
                })
                .get('read_at', null)
                .isNull()
                .value()

            this.$emit('created')
        },
        methods: {
            onHintsStoreError () {
                console.error(`Error storing hint: ${this.name}`)
            }
        }
    }
</script>
